import { AUTH_VERSION } from 'app/constants'
import { api } from 'boot/materials-api'
import { tracker } from 'boot/mixpanel'
import useAuthStore from 'src/stores/auth'
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import routes from './routes.js'

export default function () {
  const createWebFunction = process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory
  const createHistory = process.env.SERVER ? createMemoryHistory : createWebFunction

  const Router = createRouter({
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      }
      return { top: 0 }
    },
    routes,
    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? undefined : process.env.VUE_ROUTER_BASE)
  })

  Router.beforeEach(async (to) => {
    const authStore = useAuthStore()

    if (to.matched.some(record => record.meta.protected)) {
      if (authStore.isAuthenticated) {
        if (authStore.isUserCompanyInSetupMode && to.name !== 'setup-mode') {
          return { name: 'setup-mode' }
        }

        return true
      }

      const authToken = localStorage.getItem('authToken')
      const authVersion = localStorage.getItem('authVersion')

      if (!authToken || authVersion !== AUTH_VERSION) {
        return { name: 'login' }
      }

      authStore.setAuthToken(authToken)

      try {
        const user = await api.v1.users.me.get()

        authStore.setUser(user)
      }
      catch {
        return { name: 'login' }
      }

      if (
        authStore.isUserCompanyInSetupMode
        && !authStore.canManageCompany
        && to.name !== 'setup-mode'
      ) {
        return { name: 'setup-mode' }
      }
    }

    if (to.matched.some(record => record.meta.clearToken)) {
      authStore.setAuthToken(undefined)
    }

    return true
  })

  Router.afterEach((to, from, failure) => {
    if (!failure) {
      tracker.track('PageView', { page: to.name, path: to.path })
    }
  })

  return Router
}
